import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import hljs from "highlight.js";

const PreWrapper = styled.pre`
  color: ${({ theme }) => theme.colors.gray1200};
  font-family: ${({ theme }) => theme.fonts.atlas};
  margin: 3rem auto;
`;

const StyledCode = styled.code`
  padding: 1rem 2rem;
  font-size: 14px;
  line-height: 24px;
  border-radius: 2px;
  // Safety net for glitches in highlight.js, otherwise p tag content gets rendered in black color on black background.
  p {
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.atlas};
  }
`;

const CodeBlock = ({ children }) => {
  const codeRef = useRef(null);
  useEffect(() => {
    // we need to call hljs in a useEffect here for content which may not be available immediately on page load
    if (codeRef.current) {
      hljs.highlightElement(codeRef.current);
    }
  });
  return (
    <PreWrapper>
      <StyledCode ref={codeRef}>{children}</StyledCode>
    </PreWrapper>
  );
};

export default CodeBlock;
